/* eslint-disable @typescript-eslint/indent */
import React from 'react';
import { observer } from 'mobx-react';
import Styles from './index.module.scss';
import Marked from '@/component/Markdown/Plugin';

/* eslint-disable react/no-danger */
function MKDemo() {
  return (
    <div className={`${Styles.container} doc-content-body`}>
      <div className={Styles.item}>
        <h3>Header 对应的样式</h3>
        <pre>
          <div>
            #
            {' '}
            <span>一级标题</span>
          </div>
          <div>
            ##
            {' '}
            <span>二级标题</span>
          </div>
          <div>
            ###
            {' '}
            <span>三级标题</span>
          </div>
          <div>
            ####
            {' '}
            <span>四级标题</span>
          </div>
          <div>
            #####
            {' '}
            <span>五级标题</span>
          </div>
          <div>
            ######
            {' '}
            <span>六级标题</span>
          </div>
        </pre>
        <div dangerouslySetInnerHTML={{ __html: Marked.parse('# 一级标题 \n ## 二级标题 \n ### 三级标题 \n #### 四级标题 \n ##### 五级标题 \n ###### 六级标题 \n ') }} />
      </div>
      <div className={Styles.item}>
        <h3>列表 对应的样式</h3>
        <pre>
          <div>* 无序列表 1</div>
          <div>  * 无序列表 1-1</div>
          <div>     * 无序列表 1-1-1</div>
          <div>1. 有序列表 1</div>
          <div>  1. 有序列表 1-1</div>
          <div>2. 有序列表 2-1</div>
        </pre>
        <div dangerouslySetInnerHTML={{ __html: Marked.parse('* 无序列表 1\n  * 无序列表列表 1-1\n    * 无序列表列表 1-1-1 \n\n\n 1. 无序列表 1 \n    2. 无序列表 1-1 \n   1. 无序列表 2-1') }} />
      </div>
      <div className={Styles.item}>
        <h3>代码块 对应样式</h3>
        <pre>
          <div>```javascript</div>
          <div>import _ from &ldquo;lodash&rdquo;;</div>
          <div>const name = &ldquo;list&rdquo;;</div>
          <div>```</div>
        </pre>
        <div dangerouslySetInnerHTML={{ __html: Marked.parse('```javascript\nimport _ from "lodash";\nconst name = "list"; \n ```') }} />
      </div>
      <div className={Styles.item}>
        <h3>table 对应样式</h3>
        <pre>
          <div>|  表头   |  表头  |  表头 |</div>
          <div>|  ----  | ----  | ----  |</div>
          <div>| 单元格  | 单元格 | 单元格 |</div>
          <div>| 单元格  | 单元格 | 单元格 |</div>
        </pre>
        <div dangerouslySetInnerHTML={{ __html: Marked.parse('|  表头   | 表头  | 表头  |\n|  ----  | ----  | ----  |\n| 单元格  | 单元格 | 单元格 |\n| 单元格  | 单元格 | 单元格 |') }} />
      </div>

      <div className={Styles.item}>
        <h3>行内元素 对应样式</h3>
        <pre>
          <div>&gt; 这个是引用</div>
          <div>*加粗*</div>
          <div>**** // 下划线</div>
          <div>`高亮`</div>
          <div>[链接](/gateway/document/markdwon)</div>
          <div>![图片](https://sf3-cdn-tos.douyinstatic.com/obj/eden-cn/uhoahuvqeh7vhopguloj/openapi/open-api-banner-partnership.png)</div>
        </pre>
        <div dangerouslySetInnerHTML={{
          __html: Marked.parse(`> 这个是引用\n*加粗*\n\n 下划线\n ****\n\`高亮\`\n\n[链接](https://ad.oceanengine.com/gateway/document/markdwon)\n
![图片](https://p6-addone-sign.byteimg.com/tos-cn-i-hhc0kcolqq/e266839c2b934a98ac459431392ad690.svg~tplv-hhc0kcolqq-image.jpeg?x-expires=1949126056&x-signature=9CaDeI58L5mVxMQUU1HB0gnDgBg%3D)`),
        }}
        />
      </div>
      <div className={Styles.item}>
        <h3>自定义插件 对应样式</h3>
        <h4>alert</h4>
        <pre>
          <div>```alert</div>
          <div>* 提示一</div>
          <div>* 提示二</div>
          <div>* ...</div>
          <div>```</div>
        </pre>
        <div dangerouslySetInnerHTML={{ __html: Marked.parse(returnAlertString()) }} />
        <h4>xtable</h4>
        <pre>
          <div>```xtable</div>
          <div>|字段|类型|描述|</div>
          <div>|--- |--- |--- |</div>
          <div>|advertiser_id|number|广告主ID|</div>
          <div>|budget|number|广告组预算(当budget_mode=BUDGET_MODE_DAY时,广告组日预算不能低于1000元,预算单次修改幅度不能低于100元)取值范围: `≥ 0`|</div>
          <div>|budget_mode|string|广告组预算类型, 详见[【附录-预算类型】](/openapi/doc/index.html?id=528)允许值:`&ldquo;BUDGET_MODE_INFINITE&rdquo;`,`&ldquo;BUDGET_MODE_DAY&rdquo;`|</div>
          <div>
            |campaign_id
            {'{必填}'}
            |number|广告组ID|
          </div>
          <div>#|campaign_name|string|广告组名称|</div>
          <div>
            ##|modify_time
            {'{必填}'}
            |string|时间戳（从campaign/get/接口得到,用于判断是否基于最新信息修改，正确获取与填写，以免报错！)|
          </div>
          <div>```</div>
        </pre>
        <div dangerouslySetInnerHTML={{ __html: Marked.parse(returnTableString()) }} />
        <h4>xcodeblock</h4>
        <pre>
          <div>```xcodeblock</div>
          <div>(code Success-Response http)</div>
          <div>HTTPS/1.1 200 OK</div>
          <div>{'{'}</div>
          <div>&ldquo;message&rdquo;: &ldquo;OK&rdquo;,</div>
          <div>&ldquo;code&rdquo;: 0,</div>
          <div>
            &ldquo;data&rdquo;:
            {' '}
            {'{}'}
            ,
          </div>
          <div>&ldquo;request_id&rdquo;: &ldquo;2020022010373501011023224213435&rdquo;</div>
          <div>{'}'}</div>
          <div>(/code);</div>
          <div>```</div>
        </pre>
        <div dangerouslySetInnerHTML={{ __html: Marked.parse(returnCodeString()) }} />
      </div>

      <div style={{ textAlign: 'center', color: '#aaa' }}>更多插件开发中~~~</div>
    </div>
  );
}

function returnAlertString() {
  return `\`\`\`alert\n* 提示一 \n* 提示二 \n* ... \n ${'```'}`;
}

function returnTableString() {
  return `\`\`\`xtable\n${'|字段{20}|类型{20}|描述{50}|\n'
    }${'|--- |--- |--- |\n'
    }${'|advertiser_id {必填} {-废弃}|number|广告主ID|\n'
    }${'|budget|number|广告组预算(当budget_mode=BUDGET_MODE_DAY时,广告组日预算不能低于1000元,预算单次修改幅度不能低于100元)取值范围: `≥ 0`|\n'
    }${'|budget_mode|string|广告组预算类型, 详见[【附录-预算类型】](/openapi/doc/index.html?id=528)允许值:`"BUDGET_MODE_INFINITE"`,`"BUDGET_MODE_DAY"`|\n'
    }${'|campaign_id {必填}|number|广告组ID|\n'
    }${'#|campaign_name|string|广告组名称|\n'
    }${'##|modify_time {必填}|string|时间戳<span style="color:#ff0909">（从campaign/get/接口得到,用于判断是否基于最新信息修改，正确获取与填写，以免报错！)</span>|\n'
    }${'```'}`;
}

function returnCodeString() {
  return `\`\`\`xcodeblock\n${'(code Success-Response http)\n'
    }${'POST /task?id=1 HTTP/1.1\n\n'
    }${'{\n'
    }${' "message": "OK",\n'
    }${' "code": 0,\n'
    }${' "data": {},\n'
    }${' "request_id": "2020022010373501011023224213435"\n'
    }${'}\n'
    }${'(/code);\n'
    }${'```'}`;
}

export default React.memo(observer(MKDemo));
